<div class="container">
  <mat-toolbar class="items-aling">
    <span>{{ model ? 'Editar Producto' : 'Agregar Producto' }}</span>
  </mat-toolbar>

  <mat-card style="margin-top: 10px">
    <form [formGroup]="form" (ngSubmit)="model ? update(form.value) : agregar(form.value)" appPermissionControl="P193F0001">
      <mat-grid-list cols="4" rowHeight="70px">
        <mat-grid-tile [colspan]="1" [rowspan]="1">
          <ng-container>
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Perfil</mat-label>
              <input matInput placeholder="123" formControlName="clavePerfil" type="text" appPermissionControl="P193K0001" />
            </mat-form-field>
          </ng-container>
        </mat-grid-tile>

        <mat-grid-tile [colspan]="1" [rowspan]="1">
          <ng-container>
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>No. Variable</mat-label>
              <input matInput placeholder="Ejemplo..." formControlName="variable" type="text" appPermissionControl="P193K0002" />
            </mat-form-field>
          </ng-container>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="1" [rowspan]="1">
          <ng-container>
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Rango</mat-label>
              <input matInput placeholder="Ejemplo..." formControlName="rango" type="text" appPermissionControl="P193K0003" />
            </mat-form-field>
          </ng-container>
        </mat-grid-tile>

        <mat-grid-tile [colspan]="1" [rowspan]="1">
          <ng-container>
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Paquete</mat-label>
              <input matInput placeholder="Ejemplo..." formControlName="paquete" type="text" appPermissionControl="P193K0004" />
            </mat-form-field>
          </ng-container>
        </mat-grid-tile>

        <mat-grid-tile [colspan]="1" [rowspan]="1">
          <mat-form-field color="accent" appearance="outline">
            <mat-label>Producto</mat-label>
            <mat-select formControlName="producto" appPermissionControl="P193K0005">
              <mat-option *ngFor="let option of productos" [(value)]="option.producto">
                {{ option.descripcion }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile [colspan]="4">
          <span>Características</span>
        </mat-grid-tile>

        <mat-grid-tile [colspan]="1" [rowspan]="1">
          <ng-container>
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Porcentaje</mat-label>
              <input matInput placeholder="Ejemplo..." formControlName="porcentaje" type="text" appPermissionControl="P193K0006" />
            </mat-form-field>
          </ng-container> </mat-grid-tile
        ><mat-grid-tile [colspan]="1" [rowspan]="1">
          <ng-container>
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Plazo Min.</mat-label>
              <input matInput placeholder="Ejemplo..." formControlName="plazoMin" type="text" appPermissionControl="P193K0007" />
            </mat-form-field>
          </ng-container> </mat-grid-tile
        ><mat-grid-tile [colspan]="1" [rowspan]="1">
          <ng-container>
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Plazo Max.</mat-label>
              <input matInput placeholder="Ejemplo..." formControlName="plazoMax" type="text" appPermissionControl="P193K0008" />
            </mat-form-field>
          </ng-container> </mat-grid-tile
        ><mat-grid-tile [colspan]="1" [rowspan]="1">
          <ng-container>
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Tasa Min.</mat-label>
              <input matInput placeholder="Ejemplo..." formControlName="tasaMin" type="text" appPermissionControl="P193K0009" />
            </mat-form-field>
          </ng-container> </mat-grid-tile
        ><mat-grid-tile [colspan]="1" [rowspan]="1">
          <ng-container>
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Tasa Max</mat-label>
              <input matInput placeholder="Ejemplo..." formControlName="tasaMax" type="text" appPermissionControl="P193K0010" />
            </mat-form-field>
          </ng-container> </mat-grid-tile
        ><mat-grid-tile [colspan]="1" [rowspan]="1">
          <ng-container>
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>% de Crédito</mat-label>
              <input matInput placeholder="Ejemplo..." formControlName="porcCredito" type="text" appPermissionControl="P193K0011" />
            </mat-form-field>
          </ng-container> </mat-grid-tile
        ><mat-grid-tile [colspan]="1" [rowspan]="1">
          <ng-container>
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Línea Min.</mat-label>
              <input matInput placeholder="Ejemplo..." formControlName="lineaMin" type="text" appPermissionControl="P193K0012" />
            </mat-form-field>
          </ng-container> </mat-grid-tile
        ><mat-grid-tile [colspan]="1" [rowspan]="1">
          <ng-container>
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Líena Max.</mat-label>
              <input matInput placeholder="Ejemplo..." formControlName="lineaMax" type="text" appPermissionControl="P193K0013" />
            </mat-form-field>
          </ng-container>
        </mat-grid-tile>

        <mat-grid-tile [colspan]="4" [rowspan]="1">
          <button type="submit" mat-raised-button style="margin-right: 20px" color="accent" [disabled]="form.invalid" appPermissionControl="P193B0001">
            {{ model ? 'Actualizar' : 'Guardar' }}
          </button>
          <button mat-raised-button color="accent" type="button" (click)="close()" appPermissionControl="P193B0002">Cerrar</button>
        </mat-grid-tile>
      </mat-grid-list>
    </form>
  </mat-card>
</div>
